import { render, staticRenderFns } from "./dhr_ringkas.vue?vue&type=template&id=920a2e68&"
import script from "./dhr_ringkas.vue?vue&type=script&lang=js&"
export * from "./dhr_ringkas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports